module.exports = __webpack_public_path__ + "img/borne-disconnect.b0548373.png";